export const convertToFile = (base64String, fileName = "file") => {
  // Check if base64String is already a File object or null
  // console.log('BASE64',base64String)
  if (base64String instanceof File) {
    return base64String; // Return as is if it's already a File
  }

  if (typeof base64String !== "string") {
    console.error("Invalid base64 string:", base64String);
    return null; // Return null if it's not a valid string
  }

  const [contentType, base64Data] = base64String.split(",");
  const mime = contentType.match(/:(.*?);/)[1]; // Extract the MIME type dynamically

  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mime });

  // Dynamically set the file name based on MIME type or pass the name manually
  const extension = mime.split("/")[1]; // Get file extension from MIME type (e.g., png, pdf)
  const dynamicFileName = `${fileName}.${extension}`; // Example: "image.png" or "document.pdf"

  const file = new File([blob], dynamicFileName, { type: mime });
  // console.log('Converted file:', file);
  return file;
};

export const compressImage = (base64String, maxWidth = 800) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64String;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      let width = img.width;
      let height = img.height;

      // Calculate new dimensions while maintaining aspect ratio
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      // Compress with reduced quality
      const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);
      resolve(compressedBase64);
    };
  });
};

export const fileToBase64 = (file, callback) => {
  if (!(file instanceof File)) {
    console.error("Input is not a valid File object:", file);
    callback(null); // Pass null if the input is invalid
    return;
  }

  const reader = new FileReader();
  reader.onload = () => {
    // console.log("Base64 result:", reader.result);
    callback(reader.result); // Return Base64 string via callback
  };
  reader.onerror = (error) => {
    console.error("Error reading file:", error);
    callback(null); // Pass null in case of an error
  };

  reader.readAsDataURL(file);
};
